var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { PublicContent } from "./Public";
import Login from "./Auth/Login";
import AuthCallback from "./Auth/AuthCallback";
import { Home } from "./Home";
import { MUIReference } from "./MUIReference";
import { LogoutPage } from "./LogoutPage";
import { useProfileAuthStore } from "./store/ProfileStore";
import { About } from "./About";
import AgeVerification from "./AgeVerification";
import { Admin } from "./Admin";
import { Channels } from "./Channels";
import { Messaging } from "./Messaging";
import { Friends } from "./Friends";
import { Terms } from "./Terms";
import { ChannelView } from "./ChannelView";
import { ContentAdmin } from "./ContentAdmin";
import { PostView } from "./PostView";
import { ProfileView } from "./ProfileView";
import { ProfileSettings } from "./ProfileSettings";
import { Latest } from "./Latest";
import { Studio } from "./Studio";
import { useEffect } from "react";
import { useLogger } from "./logger";
import { FriendInviteLanding } from "./FriendInviteLanding";
import { NotificationsPage } from "./Notifications";
import { ContactUsPage } from "./ContactUsPage";
import Unsubscribe from "./Unsubscribe";
import Welcome from "./Welcome";
import { EditPost } from "./components/EditPost";
import { Chat } from "./Chat";
import { Navigate } from "react-router-dom";
import { saveLoginRedirect } from "./Auth/AuthUtils";
const LOGPREFIX = "App: ";
// Component to redirect /Feed to user's feed channel
function FeedRedirect() {
    const auth = useProfileAuthStore((state) => state);
    if (!auth.isSignedIn() || !auth.displayName) {
        // Save the current URL before redirecting to welcome page for post-login redirect
        saveLoginRedirect(window.location.href);
        return _jsx(Navigate, { to: "/Welcome", replace: true });
    }
    // Use getChannelViewBaseURL for proper localhost/production URL handling
    // For localhost this becomes /ChannelView?/@username, for prod it's /@username
    const channelViewPath = window.location.href.includes("localhost")
        ? `/ChannelView?/@${encodeURIComponent(auth.displayName)}`
        : `/@${encodeURIComponent(auth.displayName)}`;
    return _jsx(Navigate, { to: channelViewPath, replace: true });
}
export default function App() {
    const logger = useLogger((state) => state);
    const bearer = useProfileAuthStore((state) => state.bearer);
    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const registerPushNotifications = () => __awaiter(this, void 0, void 0, function* () {
            if (!("Notification" in window)) {
                logger.log(LOGPREFIX + "Push - NOT supported by browser");
                return;
            }
            if (Notification.permission === "granted") {
                // User has already granted permission
                logger.log(LOGPREFIX + "Push - Already granted OK");
                yield subscribeToPushNotifications();
            }
            else {
                logger.log(LOGPREFIX + "Push - Requesting Permissions");
                // Request permission from the user
                const permission = yield Notification.requestPermission();
                logger.log(LOGPREFIX + "Push - Permissions = " + permission);
                if (permission === "granted") {
                    yield subscribeToPushNotifications();
                }
            }
        });
        const subscribeToPushNotifications = () => __awaiter(this, void 0, void 0, function* () {
            logger.log(LOGPREFIX + "Push - Subscribe");
        });
        // TODO
        // registerPushNotifications();
        return () => { };
    }, []);
    let mainContent = _jsx(PublicContent, {});
    if (bearer) {
        logger.log(LOGPREFIX + "user IS signed in");
        mainContent = _jsx(Home, {});
    }
    else {
        logger.log(LOGPREFIX + "user is NOT signed in");
    }
    if (window.location.pathname.startsWith("/@")) {
        mainContent = _jsx(ChannelView, {});
    }
    return (_jsx(HelmetProvider, { children: _jsx(BrowserRouter, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/authcb", element: _jsx(AuthCallback, {}) }), _jsx(Route, { path: "/authcb.html", element: _jsx(AuthCallback, {}) }), _jsx(Route, { path: "/Contact", element: _jsx(ContactUsPage, {}) }), _jsx(Route, { path: "/About", element: _jsx(About, {}) }), _jsx(Route, { path: "/AgeVerification", element: _jsx(AgeVerification, {}) }), _jsx(Route, { path: "/Admin", element: _jsx(Admin, {}) }), _jsx(Route, { path: "/Terms", element: _jsx(Terms, {}) }), _jsx(Route, { path: "/Feed", element: _jsx(FeedRedirect, {}) }), _jsx(Route, { path: "/Channels", element: _jsx(Channels, {}) }), _jsx(Route, { path: "/Messaging", element: _jsx(Messaging, {}) }), _jsx(Route, { path: "/Friends", element: _jsx(Friends, {}) }), _jsx(Route, { path: "/FriendInvite", element: _jsx(FriendInviteLanding, {}) }), _jsx(Route, { path: "/login", element: _jsx(Login, {}) }), _jsx(Route, { path: "/Logout", element: _jsx(LogoutPage, {}) }), _jsx(Route, { path: "/muiref", element: _jsx(MUIReference, {}) }), _jsx(Route, { path: "/ChannelView", element: _jsx(ChannelView, {}) }), _jsx(Route, { path: "/ProfileView", element: _jsx(ProfileView, {}) }), _jsx(Route, { path: "/Profile", element: _jsx(ProfileSettings, {}) }), _jsx(Route, { path: "/ContentAdmin", element: _jsx(ContentAdmin, {}) }), _jsx(Route, { path: "/PostView", element: _jsx(PostView, {}) }), _jsx(Route, { path: "/EditPost", element: _jsx(EditPost, {}) }), _jsx(Route, { path: "/share", element: window.location.search.includes("postId") ? (_jsx(PostView, {})) : (_jsx(ChannelView, {})) }), _jsx(Route, { path: "/Latest", element: _jsx(Latest, {}) }), _jsx(Route, { path: "/Studio", element: _jsx(Studio, {}) }), _jsx(Route, { path: "/Chat", element: _jsx(Chat, {}) }), _jsx(Route, { path: "/Notifications", element: _jsx(NotificationsPage, {}) }), _jsx(Route, { path: "/Unsubscribe", element: _jsx(Unsubscribe, {}) }), _jsx(Route, { path: "/Welcome", element: _jsx(Welcome, {}) }), _jsx(Route, { path: "/Home", element: mainContent }), _jsxs(Route, Object.assign({ path: "/", element: mainContent }, { children: [_jsx(Route, { index: true, element: mainContent }), _jsx(Route, { path: "*", element: mainContent })] }))] }) }) }));
}
